import React from 'react';
import fire from '../firebase/firebase';
import stef from '../assets/img/stefblackwood.jpg';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // eslint-disable-line no-unused-vars

class Stef extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        stefName: null,
        stefSummary: null,
        stefMain: null
       };
    }

    componentDidMount() {

      let stefName = fire.database().ref('profile-stef-name');
      let stefSummary = fire.database().ref('profile-stef-summary');
      let stefMain = fire.database().ref('profile-stef-main');

      stefName.on('value', snapshot => {
        this.setState({stefName: snapshot.val()});
      });

      stefSummary.on('value', snapshot => {
        this.setState({stefSummary: snapshot.val()});
      });

      stefMain.on('value', snapshot => {
        this.setState({stefMain: snapshot.val()});
      });
    }

  render() {
    return (
      <div>
        <div className="app-main-container">
          <div className="app-content__heading page-heading-container">
            <div className="app-header-container page-heading">
            <h1 className="heavy">{this.state.stefName}<span className="eitx-orange">.</span></h1>
            <p>{this.state.stefSummary}</p>
            </div>
          </div>
          
          <div className="app-content main-content">
            <div className="nav-back">
              <Link to="/ourteam"><i className="fa fa-arrow-left fa-1" aria-hidden="true"></i> Back to Team view.</Link>
            </div>

            <div dangerouslySetInnerHTML={{__html: this.state.stefMain}}  className="app-content--two-thirds-summary"></div>
            <div className="app-content--one-third-right testimonial__container">
             <img className="app-tri-grid__img" src={stef} alt="Stef" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Stef;




// WEBPACK FOOTER //
// ./src/pages/stefanblackwood.js